import React from "react";
import Container from "react-bootstrap/Container";
import { IPageTeaserProps } from "./PageTeaserProps";
import {
  StyledRow,
  ImageContainer,
  ContentContainer,
} from "./PageTeaserHelpers";
import { useMobileDetectContext } from "../../../context/MobileDetectContext";

const PageTeaser: React.FC<IPageTeaserProps> = (props) => {
  const { isMobileOnly } = useMobileDetectContext();
  const bannerImage =
    props !== null && props.relationships && props.relationships.field_media
      ? props.relationships.field_media.relationships.desktopImage.gatsbyImage
      : null;

  return (
    <Container fluid="sm">
      <StyledRow>
        {isMobileOnly ? (
          <>
            {bannerImage !== null && (
              <ImageContainer
                image={bannerImage}
                alt={props.field_subtitle}
                imagePosition={
                  props.field_image_position === "right" ? "right" : ""
                }
              />
            )}
            {props.field_image_position === "right" && (
              <ContentContainer class="left" {...props} />
            )}
            {(!props.field_image_position ||
              props.field_image_position === "left") && (
              <ContentContainer {...props} />
            )}
          </>
        ) : (
          <>
            {props.field_image_position === "right" && (
              <ContentContainer class="left" {...props} />
            )}
            {bannerImage !== null && (
              <ImageContainer
                image={bannerImage}
                alt={props.field_subtitle}
                imagePosition={
                  props.field_image_position === "right" ? "right" : ""
                }
              />
            )}
            {(!props.field_image_position ||
              props.field_image_position === "left") && (
              <ContentContainer {...props} />
            )}
          </>
        )}
      </StyledRow>
    </Container>
  );
};

export default PageTeaser;
